import { Sounds } from '../../../@resources/sounds';
import { waitFor } from '../../../CodesThatsGottaGoSomewhereElse';
import { CommandDispatcher } from '../../../concepts/commands/CommandDispatcher';
import { ClientManager, Communicator } from '../../../concepts/objects';
import { AudioManager } from '../../../platform/AudioManager';
import { ActiveObject, resolve } from '../../Container';
import { Wrapper } from '../../Wrapper';
import { WidgetManager } from '../../canvas/workspace/widgets/WidgetManager';
import { AlertHub } from '../alerts/AlertHub';
import { ToastHub } from '../toast/ToastHub';
import { CountdownWidget } from './CountdownWidget';

export class CountdownController extends ActiveObject {

    @resolve(AudioManager) private audio: AudioManager;
    @resolve(AlertHub) private alerts: AlertHub;
    @resolve(Communicator) private comms: Communicator;
    @resolve(ClientManager) private clients: ClientManager;
    @resolve(CommandDispatcher) private dispatch: CommandDispatcher;
    @resolve(ToastHub) private toast: ToastHub;
    @resolve(WidgetManager) private widgets: WidgetManager;
    @resolve(Wrapper) private wrapper: Wrapper;

    private timeOfLast = 0;

    public start() {
        this.burden(
            this.comms.recv('countdown', () => this.inCountdown()),
        );
    }

    public invoke() {
        this.comms.send(this.clients.self.id, 'countdown', {});
        this.comms.send('countdown', {});
    }

    private async inCountdown() {
        // const timeSinceLast = Date.now() - this.timeOfLast;
        // if (timeSinceLast < 10000) return;
        this.timeOfLast = Date.now();

        this.audio.play(Sounds.Countdown);
        this.displayValue('3');

        await waitFor(900);
        this.displayValue('2');

        await waitFor(900);
        this.displayValue('1');

        await waitFor(900);
        this.clearDisplay();

        this.alerts.invoke({
            type: 'announcement',
            body: 'GO GO GO!',
            delay: 3000,
        });

    };

    private displayValue(value: string) {
        this.widgets.delete('countdown');

        const cont = this.widgets.createContainer({
            name: 'countdown',
            style: 'none',
            position: ['unmanaged'],
        });

        cont.add(
            this.widgets.createInline({
                ui: CountdownWidget,
                value,
            })
        );

        this.widgets.add(cont);
    }

    private clearDisplay() {
        this.widgets.delete('countdown');
    }
}

